import { useCallback, useEffect, useRef, useState } from "react";

const HEADER_OFFSET = 92;
const ACTIVE_LINE = 140;
const SMOOTH_SCROLL_MS = 1200;
const RELEASE_DISTANCE = 60;

const useActiveSection = (ids) => {
  const [activeId, setActiveId] = useState("");
  const pickedRef = useRef({ id: "", until: 0, y: 0 });
  const key = ids.join("|");

  useEffect(() => {
    const update = () => {
      const elements = key
        .split("|")
        .map((id) => document.getElementById(id))
        .filter(Boolean);
      if (elements.length === 0) return;

      const picked = pickedRef.current;
      if (picked.id) {
        if (
          performance.now() < picked.until ||
          Math.abs(window.scrollY - picked.y) < RELEASE_DISTANCE
        )
          return;
        picked.id = "";
      }

      const atBottom =
        window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 2;
      let current = elements[0];
      if (atBottom) {
        current = elements[elements.length - 1];
      } else {
        elements.forEach((element) => {
          if (element.getBoundingClientRect().top <= ACTIVE_LINE)
            current = element;
        });
      }
      setActiveId(current.id);
    };

    update();
    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, [key]);

  const goTo = useCallback((event, id) => {
    event.preventDefault();
    const element = document.getElementById(id);
    if (!element) return;

    const maxY = document.documentElement.scrollHeight - window.innerHeight;
    const y = Math.min(
      Math.max(
        element.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET,
        0,
      ),
      maxY,
    );
    pickedRef.current = { id, until: performance.now() + SMOOTH_SCROLL_MS, y };
    setActiveId(id);
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return [activeId, goTo];
};

export default useActiveSection;
